<div class="eiq-input__container">
  <span class="fs__sm fw__500"> Tags {{ required ? '(Optional)' : '' }} </span>
  <mat-form-field appearance="outline" class="eiq-input__field">
    <mat-chip-grid #chipList aria-label="Tags">
      <mat-chip *ngFor="let tag of tags; let i = index" (removed)="onRemove(i)">
        {{ tag }}
        <button matChipRemove>
          <fa-icon [icon]="faClose"></fa-icon>
        </button>
      </mat-chip>
    </mat-chip-grid>
    <input
      #tagsInput
      placeholder="Type and hit enter"
      [formControl]="tagCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="onAddTag($event)"
    />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngFor="let usedTag of usedTags$ | async" [value]="usedTag">
        {{ usedTag }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
